export default __webpack_public_path__ + "static/media/xrp.a30ac2af.png";